import { Directive, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SubscriptionLike } from 'rxjs';

@Directive({
  selector: '[digitalPlatformInviteCodeFormat]',
})
export class inviteCodeFormatDirective implements OnInit, OnDestroy {
  private previous: string;
  private subscription: SubscriptionLike;

  constructor(public ngControl: NgControl) {
    this.previous = this.ngControl.value || '';
  }

  ngOnInit() {
    this.subscription = this.ngControl.valueChanges.subscribe((data) =>
      this.onInputChange(data)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onInputChange(event) {
    if (!event) return;
    if (event === this.previous) return;

    const previous = this.previous;
    const lastChar = this.previous.substring(0, previous.length - 1);

    let newVal = event.replace('-', ''); //(/\w/g, '');

    if (newVal.length > 8) {
      newVal = newVal.substring(0, 8);
    }

    let formatted: string;

    if (newVal.length === 0) {
      newVal = '';
      formatted = '';
    } else if (newVal.length <= 4) {
      formatted = newVal.replace(/^(\w{0,4})/, '$1');
    } else {
      formatted = newVal.replace(/^(\w{0,4})(\w{0,4})/, '$1-$2');
    }

    // if (!( /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}/).test(formatted)) {
    //   this.ngControl.control.setErrors({'pattern': true});
    // } else {
    //   this.ngControl.control.setErrors(null);
    // }

    // write raw value to form control
    this.ngControl.control.setValue(formatted, { emitEvent: false });

    // write formatted value to DOM & store for next run
    this.ngControl.valueAccessor.writeValue(formatted);
    this.previous = formatted;
  }
}
